// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/login_bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?fami8ly=Rubik:wght@300;400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  height: 100%;
}

body {
  font-family: "Rubik", sans-serif;
}

.login-page {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: cover;
}

/* header a:hover img {
  background: url("../images/google-play-hover.svg") no-repeat;
} */

.sidebar::-webkit-scrollbar-track,
.sidebar nav::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.sidebar::-webkit-scrollbar,
.sidebar nav::-webkit-scrollbar {
  width: 6px;
}

.sidebar::-webkit-scrollbar-thumb,
.sidebar nav::-webkit-scrollbar-thumb {
  background-color: #63c3eb;
}

.sidebar nav a.active {
  background-color: #fff;
  color: #3E54AC;
}

.sidebar nav a.active img,
.sidebar nav a:hover img,
.sidebar nav button:hover img {
  /* filter: brightness(0) saturate(100%) invert(26%) sepia(62%) saturate(6496%) hue-rotate(248deg) brightness(98%) contrast(110%); */
  filter:invert(34%) sepia(9%) saturate(4869%) hue-rotate(195deg) brightness(64%) contrast(95%);
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-text-fill-color: #000;
  -webkit-box-shadow: 0 0 0px 1000px #fff inset;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}


.not-found {
  display: flex;
  text-align: center;
  justify-content: center;
}


.react-date-picker {
  padding: 0;
}

.react-date-picker .react-date-picker__wrapper {
  border-color: #c7bfbf;
  padding: 5px 8px;
  border-radius: 7px;
  color: #c7bfbf;
}

.react-date-picker__inputGroup__input:invalid {
  background: transparent !important;
}

.react-date-picker__button svg {
  opacity: .3;
}


@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loading-spinner {
  width: 20px;
  height: 20px;
  border: 8px solid #09fd4a;
  border-top: 10px solid #383636;
  border-radius: 50%;
  animation: spinner 1.5s linear infinite;
  margin: 0 auto;
}
button:disabled
 {
    background-color: rgb(45 50 130 / 78%);
}

button.disabled{background-color: rgb(229 231 235 / var(--tw-bg-opacity));}
/* .password_view {
  position: absolute;
  top: 40%;
  right: 20px;
  transform: translateY(-50%);
  font-size: 20px;
} */

/* .flatpickr {
  padding-right: 30px;
  background: url(../images/calender.png) no-repeat center right;
  background-color: transparent;
}

.flatpickr::after {
  content: "";
  display: block;
  position: absolute;
  background-color: transparent;
  top: 50%;
  right: 10px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 4px 0 4px;
  border-color: #333333 transparent transparent transparent;
  transform: translateY(-50%);
} */


.react-quill.custom-editor-height {
  height: 300px; /* Adjust the height as per your requirement */
}

.hideSideBar{
  display: none;
}


#scrollableDiv::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	background-color: #F5F5F5;
}

#scrollableDiv::-webkit-scrollbar
{
	width: 6px;
	background-color: #F5F5F5;
}

#scrollableDiv::-webkit-scrollbar-thumb
{
	background-color: #000000;
}
button.custom-delete-button {
  margin: 0px;
  top: -8px;
  right: -11px;
  position: absolute;
  width: 14px;
  height: 14px;
}
button.editbtn {
  position: absolute;
  top: -10px;
  right: 20px;
  border-right: 1px solid #5d5d5d;
  padding-right: 5px;
  z-index: 99999;
}
button.editbtn svg {
  width: 16px;
}


/* CSS for View Form of Form Management */
.form-view h2 {
  font-size: 1rem; /* Typical h2 size, adjust as needed */
  font-weight: bold; /* If strong isn't enough */
  margin: 1em 0; /* Add proper heading spacing */
}
.form-view h3 {
  font-size: 0.5rem; /* Typical h2 size, adjust as needed */
  font-weight: bold; /* If strong isn't enough */
  margin: 1em 0; /* Add proper heading spacing */
}

/* .dynamic-form{
    width: 860px;
    height: 525px;
    overflow: auto;
    min-height: 400px;
} */
.form-view-text-editor p{
  font-size: 14px;
}

html,
body,
#root {
  height: 100%;
}

body {
  font-family: "Rubik", sans-serif;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Sidebar menu font */
.sidebar nav a,
.sidebar nav button {
  font-family: "Rubik", sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 1.5;
}

/* Active sidebar item */
.sidebar nav a.active {
  background-color: #fff;
  color: #3E54AC;
  font-weight: 400;
}

/* Sidebar section headings */
.sidebar nav button {
  font-weight: 600;
  text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oEAAiD;EACjD,sBAAsB;AACxB;;AAEA;;GAEG;;AAEH;;EAGE,4CAA4C;AAC9C;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;;EAGE,mIAAmI;EACnI,6FAA6F;AAC/F;;AAEA;;;;;;;;;EASE,6BAA6B;EAC7B,6CAA6C;EAC7C,yDAAiD;EAAjD,iDAAiD;AACnD;;;AAGA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;AACzB;;;AAGA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;AAChB;AACA;;IAEI,sCAAsC;AAC1C;;AAEA,gBAAgB,yDAAyD,CAAC;AAC1E;;;;;;GAMG;;AAEH;;;;;;;;;;;;;;;;;;;GAmBG;;;AAGH;EACE,aAAa,EAAE,8CAA8C;AAC/D;;AAEA;EACE,aAAa;AACf;;;AAGA;;CAEC,iDAAiD;CACjD,yBAAyB;AAC1B;;AAEA;;CAEC,UAAU;CACV,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;AACA;EACE,WAAW;EACX,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;AACb;;;AAGA,yCAAyC;AACzC;EACE,eAAe,EAAE,sCAAsC;EACvD,iBAAiB,EAAE,2BAA2B;EAC9C,aAAa,EAAE,+BAA+B;AAChD;AACA;EACE,iBAAiB,EAAE,sCAAsC;EACzD,iBAAiB,EAAE,2BAA2B;EAC9C,aAAa,EAAE,+BAA+B;AAChD;;AAEA;;;;;GAKG;AACH;EACE,eAAe;AACjB;;AAKA;;;EAGE,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;;EAEE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,yBAAyB;AAC3B","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?fami8ly=Rubik:wght@300;400;500;600;700;800&display=swap\");\r\n\r\nhtml,\r\nbody,\r\n#root {\r\n  height: 100%;\r\n}\r\n\r\nbody {\r\n  font-family: \"Rubik\", sans-serif;\r\n}\r\n\r\n.login-page {\r\n  background: url(\"/login_bg.jpg\") no-repeat center;\r\n  background-size: cover;\r\n}\r\n\r\n/* header a:hover img {\r\n  background: url(\"../images/google-play-hover.svg\") no-repeat;\r\n} */\r\n\r\n.sidebar::-webkit-scrollbar-track,\r\n.sidebar nav::-webkit-scrollbar-track {\r\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\r\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.sidebar::-webkit-scrollbar,\r\n.sidebar nav::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.sidebar::-webkit-scrollbar-thumb,\r\n.sidebar nav::-webkit-scrollbar-thumb {\r\n  background-color: #63c3eb;\r\n}\r\n\r\n.sidebar nav a.active {\r\n  background-color: #fff;\r\n  color: #3E54AC;\r\n}\r\n\r\n.sidebar nav a.active img,\r\n.sidebar nav a:hover img,\r\n.sidebar nav button:hover img {\r\n  /* filter: brightness(0) saturate(100%) invert(26%) sepia(62%) saturate(6496%) hue-rotate(248deg) brightness(98%) contrast(110%); */\r\n  filter:invert(34%) sepia(9%) saturate(4869%) hue-rotate(195deg) brightness(64%) contrast(95%);\r\n}\r\n\r\ninput:-webkit-autofill,\r\ninput:-webkit-autofill:hover,\r\ninput:-webkit-autofill:focus,\r\ntextarea:-webkit-autofill,\r\ntextarea:-webkit-autofill:hover,\r\ntextarea:-webkit-autofill:focus,\r\nselect:-webkit-autofill,\r\nselect:-webkit-autofill:hover,\r\nselect:-webkit-autofill:focus {\r\n  -webkit-text-fill-color: #000;\r\n  -webkit-box-shadow: 0 0 0px 1000px #fff inset;\r\n  transition: background-color 5000s ease-in-out 0s;\r\n}\r\n\r\n\r\n.not-found {\r\n  display: flex;\r\n  text-align: center;\r\n  justify-content: center;\r\n}\r\n\r\n\r\n.react-date-picker {\r\n  padding: 0;\r\n}\r\n\r\n.react-date-picker .react-date-picker__wrapper {\r\n  border-color: #c7bfbf;\r\n  padding: 5px 8px;\r\n  border-radius: 7px;\r\n  color: #c7bfbf;\r\n}\r\n\r\n.react-date-picker__inputGroup__input:invalid {\r\n  background: transparent !important;\r\n}\r\n\r\n.react-date-picker__button svg {\r\n  opacity: .3;\r\n}\r\n\r\n\r\n@keyframes spinner {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n.loading-spinner {\r\n  width: 20px;\r\n  height: 20px;\r\n  border: 8px solid #09fd4a;\r\n  border-top: 10px solid #383636;\r\n  border-radius: 50%;\r\n  animation: spinner 1.5s linear infinite;\r\n  margin: 0 auto;\r\n}\r\nbutton:disabled\r\n {\r\n    background-color: rgb(45 50 130 / 78%);\r\n}\r\n\r\nbutton.disabled{background-color: rgb(229 231 235 / var(--tw-bg-opacity));}\r\n/* .password_view {\r\n  position: absolute;\r\n  top: 40%;\r\n  right: 20px;\r\n  transform: translateY(-50%);\r\n  font-size: 20px;\r\n} */\r\n\r\n/* .flatpickr {\r\n  padding-right: 30px;\r\n  background: url(../images/calender.png) no-repeat center right;\r\n  background-color: transparent;\r\n}\r\n\r\n.flatpickr::after {\r\n  content: \"\";\r\n  display: block;\r\n  position: absolute;\r\n  background-color: transparent;\r\n  top: 50%;\r\n  right: 10px;\r\n  width: 0;\r\n  height: 0;\r\n  border-style: solid;\r\n  border-width: 6px 4px 0 4px;\r\n  border-color: #333333 transparent transparent transparent;\r\n  transform: translateY(-50%);\r\n} */\r\n\r\n\r\n.react-quill.custom-editor-height {\r\n  height: 300px; /* Adjust the height as per your requirement */\r\n}\r\n\r\n.hideSideBar{\r\n  display: none;\r\n}\r\n\r\n\r\n#scrollableDiv::-webkit-scrollbar-track\r\n{\r\n\t-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\r\n\tbackground-color: #F5F5F5;\r\n}\r\n\r\n#scrollableDiv::-webkit-scrollbar\r\n{\r\n\twidth: 6px;\r\n\tbackground-color: #F5F5F5;\r\n}\r\n\r\n#scrollableDiv::-webkit-scrollbar-thumb\r\n{\r\n\tbackground-color: #000000;\r\n}\r\nbutton.custom-delete-button {\r\n  margin: 0px;\r\n  top: -8px;\r\n  right: -11px;\r\n  position: absolute;\r\n  width: 14px;\r\n  height: 14px;\r\n}\r\nbutton.editbtn {\r\n  position: absolute;\r\n  top: -10px;\r\n  right: 20px;\r\n  border-right: 1px solid #5d5d5d;\r\n  padding-right: 5px;\r\n  z-index: 99999;\r\n}\r\nbutton.editbtn svg {\r\n  width: 16px;\r\n}\r\n\r\n\r\n/* CSS for View Form of Form Management */\r\n.form-view h2 {\r\n  font-size: 1rem; /* Typical h2 size, adjust as needed */\r\n  font-weight: bold; /* If strong isn't enough */\r\n  margin: 1em 0; /* Add proper heading spacing */\r\n}\r\n.form-view h3 {\r\n  font-size: 0.5rem; /* Typical h2 size, adjust as needed */\r\n  font-weight: bold; /* If strong isn't enough */\r\n  margin: 1em 0; /* Add proper heading spacing */\r\n}\r\n\r\n/* .dynamic-form{\r\n    width: 860px;\r\n    height: 525px;\r\n    overflow: auto;\r\n    min-height: 400px;\r\n} */\r\n.form-view-text-editor p{\r\n  font-size: 14px;\r\n}\r\n\r\n\r\n@import url(\"https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700;800&display=swap\");\r\n\r\nhtml,\r\nbody,\r\n#root {\r\n  height: 100%;\r\n}\r\n\r\nbody {\r\n  font-family: \"Rubik\", sans-serif;\r\n  font-weight: 400;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n/* Sidebar menu font */\r\n.sidebar nav a,\r\n.sidebar nav button {\r\n  font-family: \"Rubik\", sans-serif;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  letter-spacing: 0;\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Active sidebar item */\r\n.sidebar nav a.active {\r\n  background-color: #fff;\r\n  color: #3E54AC;\r\n  font-weight: 400;\r\n}\r\n\r\n/* Sidebar section headings */\r\n.sidebar nav button {\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
